import React, { useRef, useEffect, memo } from "react";
import PT from "prop-types";
import Lottie from "lottie-web";
import { isBrowser } from "browser-or-node";

let Character = ({ data, block_id }) => {
    let CharacterAnimObj = null;
    const container = useRef(null);

    const loadAnimation = () => {
        CharacterAnimObj = Lottie.loadAnimation({
            container: container.current,
            loop: true,
            autoplay: false,
            animationData: data,
            prerender: true,
        });
    };

    useEffect(() => {
        loadAnimation();
    }, []);

    const onMouseEnter = () => {
        if (isBrowser) {
            CharacterAnimObj.play();
        }
    };
    const onMouseLeave = () => {
        if (isBrowser) {
            CharacterAnimObj.onLoopComplete = () => {
                CharacterAnimObj.stop();
            };
        }
    };

    const scrollTo = () => {
        if (isBrowser) {
            const section = document.querySelector(`#${block_id}`);
            section.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    return (
        <a
            onClick={scrollTo}
            ref={container}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            style={{ pointerEvents: "all" }}
        />
    );
};

Character = memo(Character);

Character.propTypes = {
    data: PT.any,
    block_id: PT.string,
};

export default Character;
